export const environment = {
  production: false,
  environmentName: 'beta',
  apiUrl: 'https://beta-client-api.mylabmanager.com',
};
